import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Reveal from '../components/Reveal';
import './Login.css'; // We'll assume some basic styles or reuse others

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError('Failed to log in: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-page" style={{ padding: '150px 0', minHeight: '80vh', background: '#f8f9fa' }}>
      <div className="container" style={{ maxWidth: '400px' }}>
        <Reveal>
          <div className="login-card" style={{ background: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
            <h2 className="text-center mb-4">Admin Login</h2>
            {error && <div className="alert alert-danger" style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Email</label>
                <input 
                  type="email" 
                  className="form-control" 
                  style={{ width: '100%', padding: '10px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ddd' }}
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                />
              </div>
              <div className="form-group mb-4">
                <label>Password</label>
                <input 
                  type="password" 
                  className="form-control" 
                  style={{ width: '100%', padding: '10px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ddd' }}
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
              </div>
              <button disabled={loading} className="btn btn-primary w-100" type="submit" style={{ width: '100%' }}>
                Log In
              </button>
            </form>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default Login;
